export class LoginModal {
    constructor(options = {}) {
        if (!options.loginByPassword || !options.touchSession || !options.fetchMemberDetail) {
            throw new Error('Must be provided with loginByPassword, touchSession and fetchMemberDetail apis.');
        }

        this.options = {
            onLoginSuccess: () => { },
            onLoginFail: () => { },
            ...options
        };

        this.isOpen = false;
        this.accounts = this.loadAccounts();
        this.currentAccountIndex = -1;

        this.createStyle();
        this.createElements();
        this.bindEvents();
        this.renderAccounts();
    }

    createStyle () {
        const style = document.createElement('style');
        style.textContent = `
            :root {
                --bug-primary: #0a84ff;
                --bug-bg-modal: #8080804d;
                --bug-bg-input: #0000004d;
                --bug-text-primary: #fff;
                --bug-text-secondary: #ffffff80;
                --bug-border-radius-lg: 2rem;
                --bug-border-radius-md: 1rem;
                --bug-border-radius-sm: 0.75rem;
                --bug-backdrop-blur: blur(15px);
            }
    
            .login-modal .account-info-wrapper {
                display: flex;
                align-items: center;
                gap: 12px;
                flex: 1;
            }
    
            .login-modal .account-avatar {
                width: 2rem;
                height: 2rem;
                border-radius: 50%;
                object-fit: cover;
                background-color: #212121;
                position: relative;
            }
    
            .login-modal .account-avatar::before {
                content: "";
                position: absolute;
                inset: 0;
                border: 0.0625rem solid #5e5ce6;
                border-radius: 50%;
                box-sizing: border-box;
                pointer-events: none;
                z-index: 1;
            }
    
            .login-modal .account-avatar::after {
                content: "";
                position: absolute;
                inset: -0.0625rem;
                border-radius: 50%;
                box-sizing: border-box;
                border: 0.09375rem solid var(--bug-primary);
                z-index: 2;
            }
    
            .login-modal .account-details {
                display: flex;
                flex-direction: column;
            }
    
            .login-modal .account-name {
                font-size: 1rem;
                font-weight: 500;
                color: var(--bug-text-primary);
            }
    
            .login-modal .account-loginKey {
                font-size: 0.875rem;
                color: var(--bug-text-secondary);
            }
    
            .login-modal {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 1000;
                display: none;
                align-items: center;
                justify-content: center;
                background-color: #131325a3;
                word-break: break-word;
                backdrop-filter: blur(5px);
            }
    
            .login-modal-content {
                width: 90%;
                max-width: 400px;
                border-radius: var(--bug-border-radius-lg);
                padding: 1.5rem;
                background-color: var(--bug-bg-modal);
                color: var(--bug-text-primary);
                -webkit-backdrop-filter: var(--bug-backdrop-blur);
                backdrop-filter: var(--bug-backdrop-blur);
                background-blend-mode: luminosity;
                position: relative;
                box-shadow: 0 16px 32px #212121a3;
                margin: auto;
            }
    
            .login-modal-content::before {
                content: "";
                position: absolute;
                inset: 0;
                background: linear-gradient(180deg, #fff6, #fff0 40.57% 57.44%, #ffffff1a);
                border-radius: var(--bug-border-radius-lg);
                padding: 0.0875rem;
                z-index: -1;
                mask: linear-gradient(#ffffff 0 0) content-box, linear-gradient(#ffffff 0 0);
                mask-composite: subtract;
                -webkit-mask-composite: xor;
            }
    
            .login-modal h2 {
                margin-top: 0;
                color: var(--bug-text-primary);
                text-align: center;
                font-size: 1.5rem;
                line-height: 1.4;
                margin-bottom: 1rem;
            }
    
            .login-modal .group {
                margin: 1rem 0;
            }
    
            .login-modal p {
                margin: 0.5rem 0;
                color: var(--bug-text-primary);
            }
    
            .login-modal .option {
                min-height: 2rem;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                margin-bottom: 1rem;
                gap: 0.5rem;
            }
    
            .login-modal label {
                display: inline-block;
                width: 100px;
                color: var(--bug-text-primary);
            }
    
            .login-modal input[type='text'],
            .login-modal input[type='password'] {
                max-width: none;
                flex-grow: 1;
                padding: 0 0.75rem;
                height: 2rem;
                background-color: var(--bug-bg-input);
                color: var(--bug-text-primary);
                border: none;
                border-radius: var(--bug-border-radius-md);
                -webkit-backdrop-filter: var(--bug-backdrop-blur);
                backdrop-filter: var(--bug-backdrop-blur);
                font-size: 1rem;
            }
    
            .login-modal input[type='text']::placeholder,
            .login-modal input[type='password']::placeholder {
                color: var(--bug-text-secondary);
                font-size: 1rem;
            }
    
            .login-modal input[type='text']:focus,
            .login-modal input[type='password']:focus {
                outline: none;
                box-shadow: 0 0 0 2px rgba(10, 132, 255, 0.3);
            }

            .login-modal .account-list {
                max-height: 150px;
                overflow-y: auto;
                margin-bottom: 1rem;
                border-radius: var(--bug-border-radius-md);
                padding: 0.5rem;
                background-color: rgba(0, 0, 0, 0.25);
                border: none;
                gap: 0.5rem;
                display: flex;
                flex-direction: column;
            }
    
            .login-modal .release-item {
                padding: 0.75rem;
                border-radius: var(--bug-border-radius-sm);
                cursor: pointer;
                border: none;
                display: flex;
                justify-content: space-between;
                align-items: center;
                background-color: rgba(255, 255, 255, 0.05);
                color: var(--bug-text-primary);
                transition: background-color 0.2s ease;
            }
    
            .login-modal .release-item:hover {
                background-color: rgba(255, 255, 255, 0.1);
            }
    
            .login-modal .release-item.selected {
                background-color: rgba(10, 132, 255, 0.2);
            }
    
            .login-modal .buttons {
                display: flex;
                justify-content: center;
                margin-top: 1rem;
                gap: 1rem;
            }
    
            .login-modal .modal-button {
                position: relative;
                font-family: inherit;
                font-size: 1rem;
                border: none;
                padding: 0 0.75rem;
                height: 2rem;
                border-radius: var(--bug-border-radius-md);
                overflow: hidden;
                cursor: pointer;
                font-weight: 400;
                min-width: 5.25rem;
                display: inline-flex;
                align-items: center;
                justify-content: center;
            }
    
            .login-modal .login-btn {
                background-color: var(--bug-primary);
                color: #121224;
            }
    
            .login-modal .login-btn:hover::after {
                background-color: #ffffff1a;
            }
    
            .login-modal .cancel-btn {
                background: transparent;
                color: var(--bug-text-primary);
                border: 0.0625rem solid #ffffff;
            }
    
            .login-modal .cancel-btn:hover::after {
                background-color: #fff3;
            }
    
            .login-modal .text {
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                z-index: 10;
            }
    
            .login-modal .modal-button::after {
                pointer-events: none;
                content: "";
                position: absolute;
                inset: 0;
                border-radius: inherit;
                opacity: 0;
                transition: opacity 0.2s ease;
            }
    
            .login-modal .modal-button:hover::after {
                opacity: 1;
            }
    
            .login-modal .delete-btn {
                width: 2rem;
                height: 2rem;
                margin: 0;
                padding: 0;
                border: none;
                background: transparent;
                cursor: pointer;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: var(--bug-text-secondary);
            }
    
            .login-modal .delete-btn:hover {
                background: rgba(255, 255, 255, 0.15);
                color: var(--bug-text-primary);
            }
    
            .login-modal .delete-btn:active {
                background: rgba(255, 255, 255, 0.3);
            }
    
            .login-modal .option input[type='checkbox'] {
                display: none;
            }
    
            .login-modal .option input[type='checkbox'] + label::before {
                content: "";
                display: inline-block;
                width: 1.5rem;
                height: 1.5rem;
                margin-right: 0.5rem;
                vertical-align: middle;
                background-color: var(--bug-bg-input);
                border-radius: 0.25rem;
                -webkit-backdrop-filter: var(--bug-backdrop-blur);
                backdrop-filter: var(--bug-backdrop-blur);
                position: relative;
            }
    
            .login-modal .option input[type='checkbox']:checked + label::before {
                background-color: var(--bug-primary);
            }
    
            .login-modal .option input[type='checkbox']:checked + label::after {
                content: "";
                position: absolute;
                width: 0.5rem;
                height: 0.8rem;
                border: solid #121224;
                border-width: 0 2px 2px 0;
                transform: rotate(45deg);
                left: 0.35rem;
                top: 0.15rem;
            }
    
            .login-modal .option label {
                position: relative;
                cursor: pointer;
                width: auto;
                display: flex;

                align-items: center;
            }
    
            @keyframes bug-modal-in {
                0% { opacity: 1; transform: scale(0.3); }
                30% { opacity: 1; transform: scale(1.05); }
                60% { opacity: 1; transform: scale(0.99); }f
                to { opacity: 1; transform: scale(1); }
            }
    
            @keyframes bug-modal-out {
                0% { opacity: 1; transform: scale(1); }
                to { opacity: 0; transform: scale(0.8); }
            }
    
            .login-modal {
                animation: bug-modal-out 0.3s ease-out forwards;
            }
    
            .login-modal[style*="display: flex"] {
                animation: bug-modal-in 0.6s ease-out forwards;
            }
        `;
        document.head.appendChild(style);
    }

    createElements () {
        this.modal = document.createElement('div');
        this.modal.className = 'login-modal';
        this.modal.style.display = 'none';

        this.modalContent = document.createElement('div');
        this.modalContent.className = 'login-modal-content';
        this.modal.appendChild(this.modalContent);

        const title = document.createElement('h2');
        title.textContent = '社区账号登录';
        this.modalContent.appendChild(title);

        this.accountContainer = document.createElement('div');
        this.accountContainer.className = 'group';

        const accountLabel = document.createElement('p');
        accountLabel.textContent = '已保存账户：';
        this.accountContainer.appendChild(accountLabel);

        this.accountList = document.createElement('div');
        this.accountList.className = 'account-list';
        this.accountContainer.appendChild(this.accountList);

        this.modalContent.appendChild(this.accountContainer);

        this.form = document.createElement('form');

        const idGroup = document.createElement('div');
        idGroup.className = 'option';

        const idLabel = document.createElement('label');
        idLabel.textContent = '账号：';

        this.loginKeyInput = document.createElement('input');
        this.loginKeyInput.type = 'text';
        this.loginKeyInput.required = true;

        idGroup.appendChild(idLabel);
        idGroup.appendChild(this.loginKeyInput);
        this.form.appendChild(idGroup);

        const passwordGroup = document.createElement('div');
        passwordGroup.className = 'option';

        const passwordLabel = document.createElement('label');
        passwordLabel.textContent = '密码：';

        this.passwordInput = document.createElement('input');
        this.passwordInput.type = 'password';
        this.passwordInput.required = true;

        passwordGroup.appendChild(passwordLabel);
        passwordGroup.appendChild(this.passwordInput);
        this.form.appendChild(passwordGroup);

        const rememberGroup = document.createElement('div');
        rememberGroup.className = 'option';

        this.rememberCheckbox = document.createElement('input');
        this.rememberCheckbox.type = 'checkbox';
        this.rememberCheckbox.id = 'remember-me';
        this.rememberCheckbox.checked = true;

        const rememberLabel = document.createElement('label');
        rememberLabel.textContent = '记住我';
        rememberLabel.style.marginLeft = '4px';

        rememberGroup.appendChild(this.rememberCheckbox);
        rememberGroup.appendChild(rememberLabel);
        this.form.appendChild(rememberGroup);

        const buttonContainer = document.createElement('div');
        buttonContainer.className = 'buttons';

        this.loginButton = document.createElement('button');
        this.loginButton.type = 'submit';
        this.loginButton.className = 'modal-button login-btn';
        this.loginButton.innerHTML = '<span class="text">登录</span>';

        this.cancelButton = document.createElement('button');
        this.cancelButton.type = 'button';
        this.cancelButton.className = 'modal-button cancel-btn';
        this.cancelButton.innerHTML = '<span class="text">游客</span>';

        buttonContainer.appendChild(this.loginButton);
        buttonContainer.appendChild(this.cancelButton);
        this.form.appendChild(buttonContainer);

        this.modalContent.appendChild(this.form);
        document.body.appendChild(this.modal);
    }

    bindEvents () {
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.handleLogin();
        });

        this.cancelButton.addEventListener('click', () => this.close());

        this.modal.addEventListener('click', (e) => {
            if (e.target === this.modal) this.close();
        });
    }

    renderAccounts () {
        this.accountList.innerHTML = '';

        if (this.accounts.length === 0) {
            const emptyText = document.createElement('p');
            emptyText.textContent = '暂无保存的账户';
            emptyText.style.margin = '8px 0';
            this.accountList.appendChild(emptyText);
            return;
        }

        this.accounts.forEach((account, index) => {
            const accountItem = document.createElement('div');
            accountItem.className = 'release-item';
            if (index === this.currentAccountIndex) {
                accountItem.classList.add('selected');
            }

            const accountInfoWrapper = document.createElement('div');
            accountInfoWrapper.className = 'account-info-wrapper';
            accountInfoWrapper.style.cursor = 'pointer';
            accountInfoWrapper.addEventListener('click', () => this.selectAccount(index));

            const avatar = document.createElement('img');
            avatar.className = 'account-avatar';
            avatar.src = account.avatar || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJzNC40OCAxMCAxMCAxMCAxMC00LjQ4IDEwLTEwUzE3LjUyIDIgMTIgMnptMCAxOWMtNC40MSAwLTgtMy41OS04LThzMy41OS04IDgtOCA4IDMuNTkgOCA4LTYuNTkgOC04IDh6bTAgLTRhMiAyIDAgMSAwLTIgMnYyYTIgMiAwIDAgMS00IDB2LTJhMiAyIDAgMSAwLTItMnYtMmEyIDIgMCAwIDEgMi0yaDJhMiAyIDAgMCAxIDIgMnYyYTIgMiAwIDAgMS0yIDJ2MmE0IDQgMCAwIDEtNCAwdjJjMCAuNTUuNDUgMSAxIDFzMS0uNDUgMS0xdi0yYTIgMiAwIDAgMS0yLTJINmEyIDIgMCAwIDEtMi0ydiJhMiAyIDAgMCAxIDItMmgyYTIgMiAwIDAgMSAyIDJ2MmExIDEgMCAwIDAgMSAxIDF2MmExIDEgMCAwIDAgMS0xdi0yYzAtLjU1LS40NS0xLTEtMXptNC0xM2E0IDQgMCAxIDEgNCA0IDQgNCAwIDAgMS00IDQgNCA0IDAgMCAxLTQtNC00IDQgMCAwIDEgNC00eiIvPjwvc3ZnPg==';

            const accountDetails = document.createElement('div');
            accountDetails.className = 'account-details';

            const accountName = document.createElement('span');
            accountName.className = 'account-name';
            accountName.textContent = account.name || '未知账户';

            const accountLoginKey = document.createElement('span');
            accountLoginKey.className = 'account-loginKey';
            accountLoginKey.textContent = account.studentNumber;

            accountDetails.appendChild(accountName);
            accountDetails.appendChild(accountLoginKey);
            accountInfoWrapper.appendChild(avatar);
            accountInfoWrapper.appendChild(accountDetails);

            const deleteBtn = document.createElement('button');
            deleteBtn.className = 'delete-btn';
            deleteBtn.title = '删除账户';
            deleteBtn.innerHTML = '<span>X</span>';
            deleteBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.deleteAccount(index);
            });

            accountItem.appendChild(accountInfoWrapper);
            accountItem.appendChild(deleteBtn);
            this.accountList.appendChild(accountItem);
        });
    }

    async handleLogin () {
        const loginKey = this.loginKeyInput.value.trim();
        const password = this.passwordInput.value.trim();

        if (!loginKey || !password) {
            alert('请输入账号和密码');
            return;
        }

        this.loginButton.disabled = true;
        this.loginButton.querySelector('.text').textContent = '登录中...';

        try {
            const curSession = await this.options.loginByPassword(loginKey, password);
            if (!curSession || curSession == null || !curSession.token) {
                throw new Error('Login by password failed: loginKey=' + (loginKey || 'unknown') + ', reason=Illegal session');
            }

            const memberDetail = await this.options.fetchMemberDetail(curSession.token);
            if (!memberDetail || memberDetail == null) {
                throw new Error('Login by password failed: loginKey=' + (loginKey || 'unknown') + ', reason=Illegal member identify');
            }

            const mergedData = {
                accountType: curSession.accountObjectType || null,
                accountOid: curSession.accountObjectId || null,
                loginKey
            };

            sessionStorage.setItem('lm.current.session.token', curSession.token);
            sessionStorage.setItem('lm.current.member.detail', JSON.stringify(memberDetail));
            sessionStorage.setItem('lm.current.ext', JSON.stringify(mergedData));

            if (this.rememberCheckbox.checked) {
                const encryptedPassword = this.encryptData(password);
                const existingIndex = this.accounts.findIndex(acc => acc.loginKey === loginKey);

                const accountData = {
                    loginKey,
                    encryptedPassword,
                    avatar: memberDetail.avatar,
                    name: memberDetail.name,
                    studentNumber: memberDetail.studentNumber,
                };

                if (existingIndex >= 0) {
                    this.accounts[existingIndex] = accountData;
                } else {
                    this.accounts.push(accountData);
                }

                this.saveAccounts();
                this.renderAccounts();
            }

            this.options.onLoginSuccess(memberDetail);
            this.close();

        } catch (error) {
            alert('登录失败，未知错误');
            this.options.onLoginFail(error);
        } finally {
            this.loginButton.disabled = false;
            this.loginButton.querySelector('.text').textContent = '登录';
        }
    }

    selectAccount (index) {
        this.currentAccountIndex = index;
        const account = this.accounts[index];
        this.loginKeyInput.value = account.loginKey;
        this.passwordInput.value = this.decryptData(account.encryptedPassword);
        this.renderAccounts();
    }

    deleteAccount (index) {
        if (confirm('真要删除吗？')) {
            this.accounts.splice(index, 1);
            this.saveAccounts();

            if (this.currentAccountIndex === index) {
                this.currentAccountIndex = -1;
                this.loginKeyInput.value = '';
                this.passwordInput.value = '';
            } else if (this.currentAccountIndex > index) {
                this.currentAccountIndex--;
            }

            this.renderAccounts();
        }
    }

    async switchAccount (index) {
        if (index < 0 || index >= this.accounts.length) return;

        const account = this.accounts[index];
        const curToken = sessionStorage.getItem('lm.current.session.token');
        const extraData = JSON.parse(sessionStorage.getItem('lm.current.ext') || '{}');
        const curMember = JSON.parse(sessionStorage.getItem('lm.current.member.detail') || '{}');

        if (extraData.loginKey === account.loginKey && curToken) {
            try {
                await this.options.touchSession(curToken);
                this.options.onLoginSuccess(curMember);
                return;
            } catch (error) { }
        }

        this.selectAccount(index);
        await this.handleLogin();
    }

    encryptData (data) {
        return btoa(unescape(encodeURIComponent(data)));
    }

    decryptData (encryptedData) {
        try {
            return decodeURIComponent(escape(atob(encryptedData)));
        } catch (e) {
            return '';
        }
    }

    loadAccounts () {
        try {
            const stored = localStorage.getItem('lm.global.accounts');
            return stored ? JSON.parse(stored) : [];
        } catch (e) {
            return [];
        }
    }

    saveAccounts () {
        try {
            localStorage.setItem('lm.global.accounts', JSON.stringify(this.accounts));
        } catch (e) { }
    }

    open () {
        this.modal.style.display = 'flex';
        this.isOpen = true;
        this.loginKeyInput.focus();
    }

    close () {
        this.modal.style.display = 'none';
        this.isOpen = false;
    }

    destroy () {
        this.modal.remove();
        this.isOpen = false;
    }

    hasLogin () {
        return this.accounts.length !== 0 && !!sessionStorage.getItem('lm.current.ext');
    }

    getCurrentMember () {
        try {
            return JSON.parse(sessionStorage.getItem('lm.current.member.detail') || 'null');
        } catch (e) {
            return null;
        }
    }

    getExtraData () {
        try {
            return JSON.parse(sessionStorage.getItem('lm.current.ext') || 'null');
        } catch (e) {
            return null;
        }
    }

    getCurrentToken () {
        return sessionStorage.getItem('lm.current.session.token');
    }

    logout () {
        sessionStorage.removeItem('lm.current.session.token');
        sessionStorage.removeItem('lm.current.member.detail');
        sessionStorage.removeItem('lm.current.ext');
        this.options.onLoginSuccess(null);
    }
}